// src/i18n/index.js


const ta = {
  loginHeader: "கணக்கில் உள்நுழைக",
  loginViaEmail: "மின்னஞ்சல் இணைப்பு வழியாக உள்நுழைக",
  loginViaPasskey: "பயோமெட்ரிக் வழியாக உள்நுழைக",
  loginViaPassword: "கடவுச்சொல் மூலம் உள்நுழைக",
  emailLabel: "மின்னஞ்சல்",
  emailRequired: "மின்னஞ்சல் தேவை",
  emailInvalid: "மின்னஞ்சல் செல்லுபடியாகாது",
  passwordLabel: "கடவுச்சொல்",
  passwordRequired: "கடவுச்சொல் தேவை",
  passwordMinLength: "குறைந்தது 8 எழுத்துகள் தேவை",
  passwordPattern: "எழுத்துகள் மற்றும் எண்கள் தேவை",
  loginButton: "உள்நுழைக",
  passkeyButton: "பயோமெட்ரிக் மூலம் உள்நுழையவும்",
  submitLoading: "சமர்ப்பிக்கின்றது...",
  errorLoginFail: "பிழை: பயனர் பெயர் அல்லது கடவுச்சொல் தவறானது.",
  errorGeneral: "ஏதோ தவறாகிவிட்டது. பிறகு முயற்சிக்கவும்...",
  passkeySuccess: "பயோமெட்ரிக் மூலம் வெற்றிகரமாக உள்நுழைந்தீர்கள்!",
  passkeyFail: "பயோமெட்ரிக் தோல்வியடைந்தது. மின்னஞ்சல் வழியாக உள்நுழைக.",
  emailSent: "சரிபார்ப்பு மின்னஞ்சல் அனுப்பப்பட்டது. பதிவை முடிக்க உங்கள் மின்னஞ்சலைச் பார்க்கவும்...",
};

const en = {
  loginHeader: "Login to your account",
  loginViaEmail: "Login via Email Link",
  loginViaPasskey: "Login via Face/Touch ID",
  loginViaPassword: "Login via Password",
  emailLabel: "Email",
  emailRequired: "Email is required",
  emailInvalid: "Invalid email format",
  passwordLabel: "Password",
  passwordRequired: "Password is required",
  passwordMinLength: "Minimum 8 characters required",
  passwordPattern: "Must include letters and numbers",
  loginButton: "Login",
  passkeyButton: "Login via Face/Touch ID",
  submitLoading: "Submitting...",
  errorLoginFail: "Error: Invalid username or password.",
  errorGeneral: "Something went wrong. Please try again later.",
  passkeySuccess: "Logged in successfully using biometric!",
  passkeyFail: "Biometric failed. Please login via email.",
  emailSent: "Verification email sent. Check your inbox to complete login.",
};

// Get preferred language from browser
export const getAppLanguage = () => {
  const langs = navigator.languages || [navigator.language];
  const preferredLang = langs.find((l) => l.startsWith("ta")) ? "ta" : "en";
  return preferredLang || "ta";
};

// Main export to get translated strings
export const getLocalizedStrings = (lang = null) => {
  const detectedLang = lang || getAppLanguage();
  return detectedLang.startsWith("ta") ? ta : en;
};